import { performDraw, startSessionManagement } from '@datadog/browser-core';
export var LOGGER_COOKIE_NAME = '_dd_l';
export var LoggerSessionType;
(function (LoggerSessionType) {
    LoggerSessionType["NOT_TRACKED"] = "0";
    LoggerSessionType["TRACKED"] = "1";
})(LoggerSessionType || (LoggerSessionType = {}));
export function startLoggerSession(configuration) {
    var session = startSessionManagement(LOGGER_COOKIE_NAME, function (rawType) { return computeSessionState(configuration, rawType); });
    return {
        getId: session.getId,
        isTracked: function () { return session.getType() === LoggerSessionType.TRACKED; },
    };
}
function computeSessionState(configuration, rawSessionType) {
    var sessionType;
    if (hasValidLoggerSession(rawSessionType)) {
        sessionType = rawSessionType;
    }
    else if (!performDraw(configuration.sampleRate)) {
        sessionType = LoggerSessionType.NOT_TRACKED;
    }
    else {
        sessionType = LoggerSessionType.TRACKED;
    }
    return {
        isTracked: sessionType === LoggerSessionType.TRACKED,
        type: sessionType,
    };
}
function hasValidLoggerSession(type) {
    return type === LoggerSessionType.NOT_TRACKED || type === LoggerSessionType.TRACKED;
}
//# sourceMappingURL=loggerSession.js.map